module.exports = {
    INDIVIDUAL: 'individual',
    CORPORATE: 'corporate'
};